<template>
	<!-- v-on:touchstart="bodyTouchStart" v-on:touchmove="bodyTouchMove" v-on:touchend="bodyTouchEnd" -->
	<div id="app">


		<!-- <transition :name="direction">

			<keep-alive v-if="$route.meta.keepAlive">
				<router-view class="appView"></router-view>
			</keep-alive>

			<router-view class="appView" v-else></router-view>

		</transition> -->

		<keep-alive v-if="$route.meta.keepAlive">
			<router-view></router-view>
		</keep-alive>

		<router-view v-else></router-view>



		<van-tabbar route v-if="$route.meta.bar">
			<van-tabbar-item replace to="/" icon="wap-home">
				首页
			</van-tabbar-item>

			<van-tabbar-item replace to="/help-center" icon="like">
				帮助
			</van-tabbar-item>

			<van-tabbar-item replace to="/member-center" icon="manager" :badge="unused?unused:''">
				我的
			</van-tabbar-item>
		</van-tabbar>
		<div class="go-app" v-if="show_goapp" @click="goApp">在APP中打开</div>



		<div class="wx-guide" @touchmove.prevent v-if="show && is_weixin && !is_ios">
			<div class="main">
				<div class="arrow"></div>
				<div class="text">
					<div class="flex mt-3">
						<div class="num">1</div>请点击右上角<i class="icon icon-1"></i>按钮
					</div>
					<div class="flex mt-2">
						<div class="num">2</div>选择在<i class="icon icon-2"></i>浏览器中打开
					</div>
				</div>
			</div>
		</div>
		<div class="wx-guide" @touchmove.prevent v-if="show && is_weixin && is_ios">
			<div class="main">
				<div class="arrow"></div>
				<div class="text">
					<div class="flex mt-3">
						<div class="num">1</div>请点击右上角<i class="icon icon-1"></i>按钮
					</div>
					<div class="flex mt-2">
						<div class="num">2</div>选择在<i class="icon icon-3"></i>Safari中打开
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var swidth = document.documentElement.clientWidth;
	import Vue from 'vue';
	import {
		Tabbar,
		TabbarItem
	} from 'vant';

	Vue.use(Tabbar);
	Vue.use(TabbarItem);

	export default {
		name: 'App',
		data() {
			return {
				is_weixin: navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1,
				is_ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
				// show: (this.$route.path.indexOf('group') === -1 && this.$route.path.indexOf('auth') === -1),
				show: true,
				unused: 0,
				show_goapp: false,

				// direction 页面切换的过渡动画，配合transition组件使用
				direction: "slide-left",
				// touchLeft 划动起点界限，起点在靠近屏幕左侧时才有效
				touchLeft: swidth * 2 / 5,
				// touchStartPoint 记录起始点X坐标
				touchStartPoint: 0,
				// distance 记录划动的距离
				distance: 0,
				// 回退按钮的dom，根据页面上是否存在此dom来判断该路由是否可回退
				backBtn: null
			}
		},
		watch: {
			// 监听路有变化，决定页面过渡动画
			// $route(to, from) {
			// 	console.log(to, from)
			// 	if (to.path == '/help-center' || to.path == '/member-center') {
			// 		this.direction = "";
			// 	} else if(to.path == '/'){
			// 		this.direction = "slide-left";
			// 	} else {
			// 		this.direction = from.path == '/group-center' ? "slide-left" : "slide-right";
			// 	}
			// }
		},
		mounted() {

		},
		methods: {
			bodyTouchStart: function(event) {
				// this.backBtn = document.getElementById("navback");
				this.backBtn = document.getElementsByClassName('van-icon-arrow-left')[0] || document.getElementsByClassName(
					'transition-all05')[0]
				if (this.backBtn) {
					// 获得起点X坐标，初始化distance为0
					this.touchStartPoint = event.targetTouches[0].pageX;
					this.distance = 0;
				}
			},
			bodyTouchMove: function(event) {
				if (this.backBtn && this.touchStartPoint < this.touchLeft) {
					// 只监听单指划动，多指划动不作响应
					if (event.targetTouches.length > 1) {
						return;
					}
					// 实时计算distance
					this.distance = event.targetTouches[0].pageX - this.touchStartPoint;
					// 根据distance在页面上做出反馈。这里演示通过返回按钮的背景变化作出反馈
					if (this.distance > 0 && this.distance < 100) {
						this.backBtn.style.backgroundPosition = ((this.distance - 100) / 100) * 50 + "px 0";
					} else if (this.distance >= 100) {
						this.backBtn.style.backgroundPosition = "0 0";
					} else {
						this.backBtn.style.backgroundPosition = "-50px 0";
					}
				}
			},
			bodyTouchEnd: function(event) {
				if (this.backBtn && this.touchStartPoint < this.touchLeft) {
					// 划动结束，重置数据
					this.touchStartPoint = 0;
					this.backBtn.style.backgroundPosition = "-50px 0";
					// 当划动距离超过100px时，触发返回事件
					if (this.distance > 100 && navigator.userAgent.toLowerCase().indexOf('html5plus')) {
						// 返回前修改样式，让过渡动画看起来更快
						document.getElementById("app").classList.add("quickback");

						if (this.direction == "slide-right" && this.backBtn.className.indexOf('transition') == -1) {
							this.$router.push('/member-center');
						} else {
							this.$router.back();
						}

						setTimeout(function() {
							document.getElementById("app").classList.remove("quickback");
						}, 250)
					}
				}
			},
			goApp() {
				var uri = this.$Setting.app_scheme + encodeURIComponent(location.href)
				var app_url = this.$Setting.app_url

				if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
					var loadDateTime = new Date();
					window.setTimeout(function() {
						var timeOutDateTime = new Date();
						if (timeOutDateTime - loadDateTime < 5000) {
							window.location = app_url;
						} else {
							window.close();
						}
					}, 25);
					window.location = uri;

				} else if (navigator.userAgent.match(/android/i)) {
					var loadDateTime = new Date();
					var state = window.open(uri, '_blank');
					window.setTimeout(function() {
						var timeOutDateTime = new Date();
						if (timeOutDateTime - loadDateTime < 5000) {
							window.location = app_url;
						} else {
							window.close();
						}
					}, 25);
				}
			}
		},
		created() {

			this.$ApiUtil.Setting.index().then((res) => {
				
				if (res.run_type == 'app' && navigator.userAgent.toLowerCase().indexOf('html5plus') == -1) {
					this.show_goapp = true
				}

				this.$Setting.web_title = res.web_title

				this.$Setting.web_bot_name = res.web_bot_name

				this.$Setting.run_type = res.run_type

				this.$Setting.app_url = res.app_url

				this.$Setting.app_scheme = res.app_scheme

				this.$Setting.notice = res.notice
				
				document.title = res.web_title
			})
			// alert(navigator.userAgent)
			this.unused = localStorage.getItem('unused') ? parseInt(localStorage.getItem('unused')) : 0

			document.addEventListener('touchstart', function(event) {
				if (event.touches.length > 1) {
					event.preventDefault()
				}
			})
			document.addEventListener('gesturestart', function(event) {
				event.preventDefault()
			})
		}
	}
</script>
<style>
	.go-app {
		width: 0.9rem;
		height: 0.3rem;
		background: rgba(255, 0, 0, 0.66);
		color: #fff;
		position: fixed;
		bottom: 1.2rem;
		left: 50%;
		margin-left: -0.45rem;
		border-radius: 15px;
		font-size: 12px;
		text-align: center;
		line-height: 0.3rem;
		box-shadow: 0 0 0.05rem #000;
	}


	.wx-guide {

		z-index: 999999;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, .85);
		font-size: .14rem;
	}

	.wx-guide .main {
		position: relative;
		margin: auto;
		width: 3.75rem;
		padding: .65rem .2rem 0;
		box-sizing: border-box;
	}

	.wx-guide .main .arrow {
		position: absolute;
		top: 0;
		right: .2rem;
		width: 1rem;
		height: 1rem;
		pointer-events: none;
		background: url(assets/share-1.png) right top no-repeat;
		background-size: contain;
	}

	.wx-guide .main .text {
		padding: .2rem .15rem;
		border: 1px #fff dashed;
		border-radius: .15rem;
		font-size: .13rem;
		background: #f1f1f1;
		box-shadow: 0 0 0.15rem rgba(0, 0, 0, 0.5);
	}

	.wx-guide .main .text .num {
		margin-right: .1rem;
		width: .25rem;
		height: .25rem;
		line-height: .25rem;
		text-align: center;
		border-radius: 50%;
		background: #fff;
		color: #C30D23;
		font-family: Arial;
		font-weight: bold;
	}

	.flex {
		display: flex !important;
		align-items: center !important;
	}

	.mt-3 {
		margin-top: .15rem !important;
	}

	.wx-guide .main .text .icon {
		margin: 0 .05rem;
		display: block;
		width: .25rem;
		height: .25rem;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	}

	.wx-guide .icon.icon-1 {
		background-image: url(assets/share-icon-1.png);
	}

	.wx-guide .icon.icon-2 {
		background-image: url(assets/share-icon-2.png);
	}

	.wx-guide .icon.icon-3 {
		background-image: url(assets/share-icon-3.png);
	}



	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		width: 100%;
		overflow-x: hidden;
		/* max-width: 0; */
		margin: 0 auto;
	}

	.appView {
		position: absolute;
		width: 100%;
		background: #fff;
		min-height: 100vh;
		transition: transform 0.24s ease-out;
	}

	#app.quickback .appView {
		transition-duration: 0.1s;
	}

	.slide-left-enter {
		transform: translate(100%, 0);
	}

	.slide-left-leave-active {
		transform: translate(-50%, 0);
	}

	.slide-right-enter {
		transform: translate(-50%, 0);
	}

	.slide-right-leave-active {
		transform: translate(100%, 0);
	}
</style>
